
export interface IOrderModel {
   order:IColumnOrder[];
}

export interface IColumnOrder{
    columnName:string;
    order:IOrderOption;
}

export enum IOrderOption{
    Ascending=1,
    Descending
}
